import {Select} from '@wandb/weave/components/Form/Select';
import React from 'react';

import {Secret} from '../../../../generated/graphql';
import {FILE_KEY_DELIMITER, Property} from '../../utilTypes';
import {getDisplayName} from './util';

export const SECRET_PREFIX = 'secret://';

type SecretDropdownProps = {
  property: Property;
  secrets: Secret[];
  value: string | null | undefined;
  onChange: (newValue: any, actionMeta: any) => void;
  loading?: boolean;
  error?: boolean;
};

type PropertyOption = {
  property: string;
  label?: string;
  value?: string;
};

export const SecretDropdown = ({
  secrets,
  value,
  property,
  onChange,
  loading = false,
  error = false,
}: SecretDropdownProps) => {
  const options: PropertyOption[] =
    loading || error
      ? []
      : secrets.map(secret => ({
          property: (property.file ?? '') + FILE_KEY_DELIMITER + property.key,
          label: secret.name,
          value: SECRET_PREFIX + secret.name,
        }));

  const getPlaceholderText = () => {
    if (loading) {
      return 'Loading secrets...';
    }
    if (error) {
      return 'Error loading secrets';
    }
    if (secrets.length === 0) {
      return 'No team secrets available';
    }
    return 'Select a secret';
  };

  // Find the current selected option from the options array
  const optionValue: PropertyOption | null =
    loading || error || !value
      ? null
      : options.find(option => option.value === value) || null;
  return (
    <div
      className="m-0 flex flex-col text-sm"
      key={property.key}
      data-test={property.key}>
      <div
        className="w-fit items-center rounded px-4 text-sm font-normal leading-6 text-sienna-500"
        style={{fontFamily: 'Source Code Pro, monospace'}}>
        {getDisplayName(property)}
      </div>
      <div className="my-10 text-sm font-normal leading-6 text-moon-500">
        {property.description}
      </div>
      <Select<PropertyOption, false>
        id={(property.file ?? '') + FILE_KEY_DELIMITER + property.key}
        options={options}
        value={optionValue}
        onChange={onChange}
        isDisabled={loading || error || secrets.length === 0}
        placeholder={getPlaceholderText()}
      />
    </div>
  );
};
